module.exports = __webpack_public_path__ + "static/logo-6c0487cbacd13174c20046b2aeed275b.svg";